var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33,
    d: "M8.333 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 14 4.08 14 5.2 14h6.133c.62 0 .93 0 1.185-.068a2 2 0 0 0 1.414-1.414c.068-.255.068-.565.068-1.185m-1.333-6v-4m-2 2h4M7 5.667a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0Zm2.993 2.278-5.639 5.127c-.317.288-.476.433-.49.558a.333.333 0 0 0 .111.287c.095.083.31.083.738.083h6.258c.96 0 1.439 0 1.816-.161a2 2 0 0 0 1.052-1.052C14 12.41 14 11.93 14 10.97c0-.323 0-.485-.035-.635a1.333 1.333 0 0 0-.25-.518c-.095-.122-.22-.223-.473-.424l-1.865-1.492c-.252-.202-.378-.303-.517-.339a.667.667 0 0 0-.372.012c-.136.044-.256.153-.495.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.d0ca7b53dc9130b2e41a79879ff873e9.svg";
export { ForwardRef as ReactComponent };